export const areaInfo = [
  {
    areacode: '+66',
    translate: {
      en: 'Thailand',
      id: 'Thailand',
      th: 'ประเทศไทย',
      vi: 'Thailand',
      'zh-cn': '泰国',
      'zh-tw': '泰國',
    },
  },
  {
    areacode: '+86',
    translate: {
      en: 'China',
      id: 'Cina',
      th: 'จีน',
      vi: 'China',
      'zh-cn': '中国',
      'zh-tw': '中國',
    },
  },
  {
    areacode: '+1',
    translate: {
      en: 'United States',
      id: 'Amerika Serikat',
      th: 'สหรัฐอเมริกา',
      vi: 'United States',
      'zh-cn': '美国',
      'zh-tw': '美國',
    },
  },
  {
    areacode: '+81',
    translate: {
      en: 'Japan',
      id: 'Jepang',
      th: 'ญี่ปุ่น',
      vi: 'Japan',
      'zh-cn': '日本',
      'zh-tw': '日本',
    },
  },
  {
    areacode: '+852',
    translate: {
      en: 'Hong Kong, China',
      id: 'Hong Kong, China',
      th: 'ฮ่องกง, ประเทศจีน',
      vi: 'Hong Kong, China',
      'zh-cn': '中國香港',
      'zh-tw': '中國香港',
    },
  },
  {
    areacode: '+886',
    translate: {
      en: 'Taiwan, China',
      id: 'Taiwan, China',
      th: 'ไต้หวัน, ประเทศจีน',
      vi: 'Taiwan, China',
      'zh-cn': '中國台湾',
      'zh-tw': '中國臺灣',
    },
  },
  {
    areacode: '+60',
    translate: {
      en: 'Malaysia',
      id: 'Malaysia',
      th: 'มาเลเซีย',
      vi: 'Malaysia',
      'zh-cn': '马来西亚',
      'zh-tw': '馬來西亞',
    },
  },
  {
    areacode: '+61',
    translate: {
      en: 'Australia',
      id: 'Australia',
      th: 'ออสเตรเลีย',
      vi: 'Australia',
      'zh-cn': '澳大利亚',
      'zh-tw': '澳大利亞',
    },
  },
  {
    areacode: '+1',
    translate: {
      en: 'Canada',
      id: 'Kanada',
      th: 'แคนาดา',
      vi: 'Canada',
      'zh-cn': '加拿大',
      'zh-tw': '加拿大',
    },
  },
  {
    areacode: '+44',
    translate: {
      en: 'United Kingdom',
      id: 'Inggris',
      th: 'สหราชอาณาจักร',
      vi: 'United Kingdom',
      'zh-cn': '英国',
      'zh-tw': '英國',
    },
  },
  {
    areacode: '+65',
    translate: {
      en: 'Singapore',
      id: 'Singapura',
      th: 'สิงคโปร์',
      vi: 'Singapore',
      'zh-cn': '新加坡',
      'zh-tw': '新加坡',
    },
  },
  {
    areacode: '+49',
    translate: {
      en: 'Germany',
      id: 'Jerman',
      th: 'เยอรมนี',
      vi: 'Germany',
      'zh-cn': '德国',
      'zh-tw': '德國',
    },
  },
  {
    areacode: '+7',
    translate: {
      en: 'Russia',
      id: 'Rusia',
      th: 'รัสเซีย',
      vi: 'Russia',
      'zh-cn': '俄罗斯',
      'zh-tw': '俄羅斯',
    },
  },
  {
    areacode: '+20',
    translate: {
      en: 'Egypt',
      id: 'Mesir',
      th: 'อียิปต์',
      vi: 'Egypt',
      'zh-cn': '埃及',
      'zh-tw': '埃及',
    },
  },
  {
    areacode: '+27',
    translate: {
      en: 'South Africa',
      id: 'Afrika Selatan',
      th: 'แอฟริกาใต้',
      vi: 'South Africa',
      'zh-cn': '南非',
      'zh-tw': '南非',
    },
  },
  {
    areacode: '+30',
    translate: {
      en: 'Greece',
      id: 'Yunani',
      th: 'กรีซ',
      vi: 'Greece',
      'zh-cn': '希腊',
      'zh-tw': '希臘',
    },
  },
  {
    areacode: '+31',
    translate: {
      en: 'Netherlands',
      id: 'Belanda',
      th: 'เนเธอร์แลนด์',
      vi: 'Netherlands',
      'zh-cn': '荷兰',
      'zh-tw': '荷蘭',
    },
  },
  {
    areacode: '+32',
    translate: {
      en: 'Belgium',
      id: 'Belgia',
      th: 'เบลเยียม',
      vi: 'Belgium',
      'zh-cn': '比利时',
      'zh-tw': '比利時',
    },
  },
  {
    areacode: '+33',
    translate: {
      en: 'France',
      id: 'Perancis',
      th: 'ฝรั่งเศส',
      vi: 'France',
      'zh-cn': '法国',
      'zh-tw': '法國',
    },
  },
  {
    areacode: '+34',
    translate: {
      en: 'Spain',
      id: 'Spanyol',
      th: 'สเปน',
      vi: 'Spain',
      'zh-cn': '西班牙',
      'zh-tw': '西班牙',
    },
  },
  {
    areacode: '+36',
    translate: {
      en: 'Hungary',
      id: 'Hongaria',
      th: 'ฮังการี',
      vi: 'Hungary',
      'zh-cn': '匈牙利',
      'zh-tw': '匈牙利',
    },
  },
  {
    areacode: '+39',
    translate: {
      en: 'Italy',
      id: 'Italia',
      th: 'อิตาลี',
      vi: 'Italy',
      'zh-cn': '意大利',
      'zh-tw': '意大利',
    },
  },
  {
    areacode: '+40',
    translate: {
      en: 'Romania',
      id: 'Romania',
      th: 'โรมาเนีย',
      vi: 'Romania',
      'zh-cn': '罗马尼亚',
      'zh-tw': '羅馬尼亞',
    },
  },
  {
    areacode: '+41',
    translate: {
      en: 'Switzerland',
      id: 'Swiss',
      th: 'สวิตเซอร์แลนด์',
      vi: 'Switzerland',
      'zh-cn': '瑞士',
      'zh-tw': '瑞士',
    },
  },
  {
    areacode: '+43',
    translate: {
      en: 'Austria',
      id: 'Austria',
      th: 'ออสเตรีย',
      vi: 'Austria',
      'zh-cn': '奥地利',
      'zh-tw': '奧地利',
    },
  },
  {
    areacode: '+45',
    translate: {
      en: 'Denmark',
      id: 'Denmark',
      th: 'เดนมาร์ก',
      vi: 'Denmark',
      'zh-cn': '丹麦',
      'zh-tw': '丹麥',
    },
  },
  {
    areacode: '+46',
    translate: {
      en: 'Sweden',
      id: 'Swedia',
      th: 'สวีเดน',
      vi: 'Sweden',
      'zh-cn': '瑞典',
      'zh-tw': '瑞典',
    },
  },
  {
    areacode: '+47',
    translate: {
      en: 'Norway',
      id: 'Norwegia',
      th: 'นอร์เวย์',
      vi: 'Norway',
      'zh-cn': '挪威',
      'zh-tw': '挪威',
    },
  },
  {
    areacode: '+48',
    translate: {
      en: 'Poland',
      id: 'Polandia',
      th: 'โปแลนด์',
      vi: 'Poland',
      'zh-cn': '波兰',
      'zh-tw': '波蘭',
    },
  },
  {
    areacode: '+51',
    translate: {
      en: 'Peru',
      id: 'Peru',
      th: 'เปรู',
      vi: 'Peru',
      'zh-cn': '秘鲁',
      'zh-tw': '秘魯',
    },
  },
  {
    areacode: '+52',
    translate: {
      en: 'Mexico',
      id: 'Meksiko',
      th: 'เม็กซิโก',
      vi: 'Mexico',
      'zh-cn': '墨西哥',
      'zh-tw': '墨西哥',
    },
  },
  {
    areacode: '+53',
    translate: {
      en: 'Cuba',
      id: 'Kuba',
      th: 'คิวบา',
      vi: 'Cuba',
      'zh-cn': '古巴',
      'zh-tw': '古巴',
    },
  },
  {
    areacode: '+54',
    translate: {
      en: 'Argentina',
      id: 'Argentina',
      th: 'อาร์เจนตินา',
      vi: 'Argentina',
      'zh-cn': '阿根廷',
      'zh-tw': '阿根廷',
    },
  },
  {
    areacode: '+55',
    translate: {
      en: 'Brazil',
      id: 'Brazil',
      th: 'บราซิล',
      vi: 'Brazil',
      'zh-cn': '巴西',
      'zh-tw': '巴西',
    },
  },
  {
    areacode: '+56',
    translate: {
      en: 'Chile',
      id: 'Chili',
      th: 'ชิลี',
      vi: 'Chile',
      'zh-cn': '智利',
      'zh-tw': '智利',
    },
  },
  {
    areacode: '+57',
    translate: {
      en: 'Colombia',
      id: 'Kolombia',
      th: 'โคลอมเบีย',
      vi: 'Colombia',
      'zh-cn': '哥伦比亚',
      'zh-tw': '哥倫比亞',
    },
  },
  {
    areacode: '+58',
    translate: {
      en: 'Venezuela',
      id: 'Venezuela',
      th: 'เวเนซุเอลา',
      vi: 'Venezuela',
      'zh-cn': '委内瑞拉',
      'zh-tw': '委內瑞拉',
    },
  },
  {
    areacode: '+62',
    translate: {
      en: 'Indonesia',
      id: 'Indonesia',
      th: 'อินโดนีเซีย',
      vi: 'Indonesia',
      'zh-cn': '印度尼西亚',
      'zh-tw': '印度尼西亞',
    },
  },
  {
    areacode: '+63',
    translate: {
      en: 'Philippines',
      id: 'Filipina',
      th: 'ฟิลิปปินส์',
      vi: 'Philippines',
      'zh-cn': '菲律宾',
      'zh-tw': '菲律賓',
    },
  },
  {
    areacode: '+64',
    translate: {
      en: 'New Zealand',
      id: 'Selandia Baru',
      th: 'นิวซีแลนด์',
      vi: 'New Zealand',
      'zh-cn': '新西兰',
      'zh-tw': '新西蘭',
    },
  },
  {
    areacode: '+7',
    translate: {
      en: 'Kazakhstan',
      id: 'Kazakhstan',
      th: 'คาซัคสถาน',
      vi: 'Kazakhstan',
      'zh-cn': '哈萨克斯坦',
      'zh-tw': '哈薩克斯坦',
    },
  },
  {
    areacode: '+82',
    translate: {
      en: 'South Korea',
      id: 'Korea Selatan',
      th: 'เกาหลีใต้',
      vi: ' Hàn Quốc ',
      'zh-cn': '韩国',
      'zh-tw': '韓國',
    },
  },
  {
    areacode: '+84',
    translate: {
      en: 'Vietnam',
      id: 'Vietnam',
      th: 'เวียดนาม',
      vi: ' Việt Nam ',
      'zh-cn': '越南',
      'zh-tw': '越南',
    },
  },
  {
    areacode: '+90',
    translate: {
      en: 'Turkey',
      id: 'Turki',
      th: 'ตุรกี',
      vi: ' Thổ Nhĩ Kỳ ',
      'zh-cn': '土耳其',
      'zh-tw': '土耳其',
    },
  },
  {
    areacode: '+91',
    translate: {
      en: 'India',
      id: 'India',
      th: 'อินเดีย',
      vi: ' Ấn Độ ',
      'zh-cn': '印度',
      'zh-tw': '印度',
    },
  },
  {
    areacode: '+92',
    translate: {
      en: 'Pakistan',
      id: 'Pakistan',
      th: 'ปากีสถาน',
      vi: ' Pakistan ',
      'zh-cn': '巴基斯坦',
      'zh-tw': '巴基斯坦',
    },
  },
  {
    areacode: '+93',
    translate: {
      en: 'Afghanistan',
      id: 'Afghanistan',
      th: 'อัฟกานิสถาน',
      vi: ' Afghanistan ',
      'zh-cn': '阿富汗',
      'zh-tw': '阿富汗',
    },
  },
  {
    areacode: '+94',
    translate: {
      en: 'Sri Lanka',
      id: 'Sri Lanka',
      th: 'ศรีลังกา',
      vi: ' Sri Lanka ',
      'zh-cn': '斯里兰卡',
      'zh-tw': '斯裏蘭卡',
    },
  },
  {
    areacode: '+95',
    translate: {
      en: 'Myanmar',
      id: 'Myanmar',
      th: 'พม่า',
      vi: ' Myanmar ',
      'zh-cn': '缅甸',
      'zh-tw': '緬甸',
    },
  },
  {
    areacode: '+98',
    translate: {
      en: 'Iran',
      id: 'Iran',
      th: 'อิหร่าน',
      vi: ' Iran ',
      'zh-cn': '伊朗',
      'zh-tw': '伊朗',
    },
  },
  {
    areacode: '+212',
    translate: {
      en: 'Morocco',
      id: 'Maroko',
      th: 'โมร็อกโก',
      vi: ' Ma-rốc ',
      'zh-cn': '摩洛哥',
      'zh-tw': '摩洛哥',
    },
  },
  {
    areacode: '+213',
    translate: {
      en: 'Algeria',
      id: 'Aljazair',
      th: 'แอลจีเรีย',
      vi: ' Algeria ',
      'zh-cn': '阿尔及利亚',
      'zh-tw': '阿爾及利亞',
    },
  },
  {
    areacode: '+216',
    translate: {
      en: 'Tunisia',
      id: 'Tunisia',
      th: 'ตูนิเซีย',
      vi: ' Tunisia ',
      'zh-cn': '突尼斯',
      'zh-tw': '突尼斯',
    },
  },
  {
    areacode: '+218',
    translate: {
      en: 'Libya',
      id: 'Libya',
      th: 'ลิเบีย',
      vi: ' Libya ',
      'zh-cn': '利比亚',
      'zh-tw': '利比亞',
    },
  },
  {
    areacode: '+220',
    translate: {
      en: 'Gambia',
      id: 'Gambia',
      th: 'แกมเบีย',
      vi: ' Gambia ',
      'zh-cn': '冈比亚',
      'zh-tw': '岡比亞',
    },
  },
  {
    areacode: '+221',
    translate: {
      en: 'Senegal',
      id: 'Senegal',
      th: 'เซเนกัล',
      vi: ' Sénégal ',
      'zh-cn': '塞内加尔',
      'zh-tw': '塞內加爾',
    },
  },
  {
    areacode: '+223',
    translate: {
      en: 'Mali',
      id: 'Mali',
      th: 'มาลี',
      vi: ' Mali ',
      'zh-cn': '马里',
      'zh-tw': '馬裏',
    },
  },
  {
    areacode: '+224',
    translate: {
      en: 'Guinea',
      id: 'Guinea',
      th: 'กินี',
      vi: ' Guinea ',
      'zh-cn': '几内亚',
      'zh-tw': '幾內亞',
    },
  },
  {
    areacode: '+225',
    translate: {
      // eslint-disable-next-line
      en: "Côte d'Ivoire",
      id: 'Pantai Gading',
      th: 'ไอวอรี่โคสต์',
      // eslint-disable-next-line
      vi: "Côte d'Ivoire",
      'zh-cn': '科特迪瓦',
      'zh-tw': '科特迪瓦',
    },
  },
  {
    areacode: '+226',
    translate: {
      en: 'Burkina Faso',
      id: 'Burkina Faso',
      th: 'บูร์กินาฟาโซ',
      vi: ' Burkina Faso ',
      'zh-cn': '布基纳法索',
      'zh-tw': '布基納法索',
    },
  },
  {
    areacode: '+227',
    translate: {
      en: 'Niger',
      id: 'Niger',
      th: 'ไนเจอร์',
      vi: ' Nigeria ',
      'zh-cn': '尼日尔',
      'zh-tw': '尼日爾',
    },
  },
  {
    areacode: '+228',
    translate: {
      en: 'Togo',
      id: 'Togo',
      th: 'โตโก',
      vi: ' Togo ',
      'zh-cn': '多哥',
      'zh-tw': '多哥',
    },
  },
  {
    areacode: '+229',
    translate: {
      en: 'Benin',
      id: 'Benin',
      th: 'เบนิน',
      vi: ' Bénin ',
      'zh-cn': '贝宁',
      'zh-tw': '貝寧',
    },
  },
  {
    areacode: '+230',
    translate: {
      en: 'Mauritius',
      id: 'Mauritius',
      th: 'มอริเชียส',
      vi: ' Mauritius ',
      'zh-cn': '毛里求斯',
      'zh-tw': '毛裏求斯',
    },
  },
  {
    areacode: '+231',
    translate: {
      en: 'Liberia',
      id: 'Liberia',
      th: 'ไลบีเรีย',
      vi: ' Liberia ',
      'zh-cn': '利比里亚',
      'zh-tw': '利比裏亞',
    },
  },
  {
    areacode: '+232',
    translate: {
      en: 'Sierra Leone',
      id: 'Sierra Leone',
      th: 'เซียร์ราลีโอน',
      vi: ' Sierra Leone ',
      'zh-cn': '塞拉利昂',
      'zh-tw': '塞拉利昂',
    },
  },
  {
    areacode: '+233',
    translate: {
      en: 'Ghana',
      id: 'Ghana',
      th: 'ประเทศกานา',
      vi: ' Ghana ',
      'zh-cn': '加纳',
      'zh-tw': '加納',
    },
  },
  {
    areacode: '+234',
    translate: {
      en: 'Nigeria',
      id: 'Nigeria',
      th: 'ไนจีเรีย',
      vi: ' Nigeria ',
      'zh-cn': '尼日利亚',
      'zh-tw': '尼日利亞',
    },
  },
  {
    areacode: '+235',
    translate: {
      en: 'Chad',
      id: 'Chad',
      th: 'ชาด',
      vi: ' Chad ',
      'zh-cn': '乍得',
      'zh-tw': '乍得',
    },
  },
  {
    areacode: '+236',
    translate: {
      en: 'Central African Republic',
      id: 'Republik Afrika Tengah',
      th: 'สาธารณรัฐแอฟริกากลาง',
      vi: ' Cộng hòa Trung Phi ',
      'zh-cn': '中非共和国',
      'zh-tw': '中非共和國',
    },
  },
  {
    areacode: '+237',
    translate: {
      en: 'Cameroon',
      id: 'Kamerun',
      th: 'แคเมอรูน',
      vi: ' Cameroon ',
      'zh-cn': '喀麦隆',
      'zh-tw': '喀麥隆',
    },
  },
  {
    areacode: '+239',
    translate: {
      en: 'Sao Tome and Principe',
      id: 'Sao Tome dan Principe',
      th: 'เซาตูเมและปรินซิปี',
      vi: ' Sao Tome và Principe ',
      'zh-cn': '圣多美和普林西比',
      'zh-tw': '聖多美和普林西比',
    },
  },
  {
    areacode: '+241',
    translate: {
      en: 'Gabon',
      id: 'Gabon',
      th: 'กาบอง',
      vi: ' Gabon ',
      'zh-cn': '加蓬',
      'zh-tw': '加蓬',
    },
  },
  {
    areacode: '+243',
    translate: {
      en: 'Democratic Republic of the Congo',
      id: 'Republik Demokratik Kongo',
      th: 'สาธารณรัฐประชาธิปไตยคองโก',
      vi: ' Cộng hòa Dân chủ Congo ',
      'zh-cn': '刚果共和国',
      'zh-tw': '剛果共和國',
    },
  },
  {
    areacode: '+244',
    translate: {
      en: 'Angola',
      id: 'Angola',
      th: 'แองโกลา',
      vi: ' Angola ',
      'zh-cn': '安哥拉',
      'zh-tw': '安哥拉',
    },
  },
  {
    areacode: '+247',
    translate: {
      en: 'Ascension Island',
      id: 'Pulau Ascension',
      th: 'เกาะสวรรค์',
      vi: ' Đảo Ascension ',
      'zh-cn': '阿森松岛',
      'zh-tw': '阿森松島',
    },
  },
  {
    areacode: '+248',
    translate: {
      en: 'Seychelles',
      id: 'Seychelles',
      th: 'เซเชลส์',
      vi: ' Seychelles ',
      'zh-cn': '塞舌尔',
      'zh-tw': '塞舌爾',
    },
  },
  {
    areacode: '+249',
    translate: {
      en: 'Sudan',
      id: 'Sudan',
      th: 'ซูดาน',
      vi: ' Sudan ',
      'zh-cn': '苏丹',
      'zh-tw': '蘇丹',
    },
  },
  {
    areacode: '+251',
    translate: {
      en: 'Ethiopia',
      id: 'Ethiopia',
      th: 'เอธิโอเปีย',
      vi: ' Ethiopia ',
      'zh-cn': '埃塞俄比亚',
      'zh-tw': '埃塞俄比亞',
    },
  },
  {
    areacode: '+252',
    translate: {
      en: 'Somalia',
      id: 'Somalia',
      th: 'โซมาเลีย',
      vi: ' Somalia ',
      'zh-cn': '索马里',
      'zh-tw': '索馬裏',
    },
  },
  {
    areacode: '+253',
    translate: {
      en: 'Djibouti',
      id: 'Djibouti',
      th: 'จิบูตี',
      vi: ' Djibouti ',
      'zh-cn': '吉布提',
      'zh-tw': '吉布提',
    },
  },
  {
    areacode: '+254',
    translate: {
      en: 'Kenya',
      id: 'Kenya',
      th: 'เคนยา',
      vi: ' Kenya ',
      'zh-cn': '肯尼亚',
      'zh-tw': '肯尼亞',
    },
  },
  {
    areacode: '+255',
    translate: {
      en: 'Tanzania',
      id: 'Tanzania',
      th: 'แทนซาเนีย',
      vi: ' Tanzania ',
      'zh-cn': '坦桑尼亚',
      'zh-tw': '坦桑尼亞',
    },
  },
  {
    areacode: '+256',
    translate: {
      en: 'Uganda',
      id: 'Uganda',
      th: 'ยูกันดา',
      vi: ' Uganda ',
      'zh-cn': '乌干达',
      'zh-tw': '烏幹達',
    },
  },
  {
    areacode: '+257',
    translate: {
      en: 'Burundi',
      id: 'Burundi',
      th: 'บุรุนดี',
      vi: ' Burundi ',
      'zh-cn': '布隆迪',
      'zh-tw': '布隆迪',
    },
  },
  {
    areacode: '+258',
    translate: {
      en: 'Mozambique',
      id: 'Mozambik',
      th: 'โมซัมบิก',
      vi: ' Mozambique ',
      'zh-cn': '莫桑比克',
      'zh-tw': '莫桑比克',
    },
  },
  {
    areacode: '+260',
    translate: {
      en: 'Zambia',
      id: 'Zambia',
      th: 'แซมเบีย',
      vi: ' Zambia ',
      'zh-cn': '赞比亚',
      'zh-tw': '贊比亞',
    },
  },
  {
    areacode: '+261',
    translate: {
      en: 'Madagascar',
      id: 'Madagaskar',
      th: 'มาดากัสการ์',
      vi: ' Madagascar ',
      'zh-cn': '马达加斯加',
      'zh-tw': '馬達加斯加',
    },
  },
  {
    areacode: '+263',
    translate: {
      en: 'Zimbabwe',
      id: 'Zimbabwe',
      th: 'ซิมบับเว',
      vi: ' Zimbabwe ',
      'zh-cn': '津巴布韦',
      'zh-tw': '津巴布韋',
    },
  },
  {
    areacode: '+264',
    translate: {
      en: 'Namibia',
      id: 'Namibia',
      th: 'นามิเบีย',
      vi: ' Namibia ',
      'zh-cn': '纳米比亚',
      'zh-tw': '納米比亞',
    },
  },
  {
    areacode: '+265',
    translate: {
      en: 'Malawi',
      id: 'Malawi',
      th: 'มาลาวี',
      vi: ' Ma-rốc ',
      'zh-cn': '马拉维',
      'zh-tw': '馬拉維',
    },
  },
  {
    areacode: '+266',
    translate: {
      en: 'Lesotho',
      id: 'Lesotho',
      th: 'เลโซโท',
      vi: ' Lesicia ',
      'zh-cn': '莱索托',
      'zh-tw': '萊索托',
    },
  },
  {
    areacode: '+267',
    translate: {
      en: 'Botswana',
      id: 'Botswana',
      th: 'บอตสวานา',
      vi: ' Botswana ',
      'zh-cn': '博茨瓦纳',
      'zh-tw': '博茨瓦納',
    },
  },
  {
    areacode: '+268',
    translate: {
      en: 'Swaziland',
      id: 'Swaziland',
      th: 'สวาซิแลนด์',
      vi: ' Swaziland ',
      'zh-cn': '斯威士兰',
      'zh-tw': '斯威士蘭',
    },
  },
  {
    areacode: '+350',
    translate: {
      en: 'Gibraltar',
      id: 'Gibraltar',
      th: 'ยิบรอลตาร์',
      vi: ' Gibraltar ',
      'zh-cn': '直布罗陀',
      'zh-tw': '直布羅陀',
    },
  },
  {
    areacode: '+351',
    translate: {
      en: 'Portugal',
      id: 'Portugal',
      th: 'โปรตุเกส',
      vi: ' Bồ Đào Nha ',
      'zh-cn': '葡萄牙',
      'zh-tw': '葡萄牙',
    },
  },
  {
    areacode: '+352',
    translate: {
      en: 'Luxembourg',
      id: 'Luksemburg',
      th: 'ลักเซมเบิร์ก',
      vi: ' Luxembourg ',
      'zh-cn': '卢森堡',
      'zh-tw': '盧森堡',
    },
  },
  {
    areacode: '+353',
    translate: {
      en: 'Ireland',
      id: 'Irlandia',
      th: 'ไอร์แลนด์',
      vi: ' Ireland ',
      'zh-cn': '爱尔兰',
      'zh-tw': '愛爾蘭',
    },
  },
  {
    areacode: '+354',
    translate: {
      en: 'Iceland',
      id: 'Islandia',
      th: 'ไอซ์แลนด์',
      vi: ' Iceland ',
      'zh-cn': '冰岛',
      'zh-tw': '冰島',
    },
  },
  {
    areacode: '+355',
    translate: {
      en: 'Albania',
      id: 'Albania',
      th: 'แอลเบเนีย',
      vi: ' Albania ',
      'zh-cn': '阿尔巴尼亚',
      'zh-tw': '阿爾巴尼亞',
    },
  },
  {
    areacode: '+356',
    translate: {
      en: 'Malta',
      id: 'Malta',
      th: 'มอลตา',
      vi: ' Malta ',
      'zh-cn': '马耳他',
      'zh-tw': '馬耳他',
    },
  },
  {
    areacode: '+357',
    translate: {
      en: 'Cyprus',
      id: 'Siprus',
      th: 'ไซปรัส',
      vi: ' Síp ',
      'zh-cn': '塞浦路斯',
      'zh-tw': '塞浦路斯',
    },
  },
  {
    areacode: '+358',
    translate: {
      en: 'Finland',
      id: 'Finlandia',
      th: 'ฟินแลนด์',
      vi: ' Phần Lan ',
      'zh-cn': '芬兰',
      'zh-tw': '芬蘭',
    },
  },
  {
    areacode: '+359',
    translate: {
      en: 'Bulgaria',
      id: 'Bulgaria',
      th: 'บัลแกเรีย',
      vi: ' Bulgaria ',
      'zh-cn': '保加利亚',
      'zh-tw': '保加利亞',
    },
  },
  {
    areacode: '+370',
    translate: {
      en: 'Lithuania',
      id: 'Lithuania',
      th: 'ลิทัวเนีย',
      vi: ' Litva ',
      'zh-cn': '立陶宛',
      'zh-tw': '立陶宛',
    },
  },
  {
    areacode: '+371',
    translate: {
      en: 'Latvia',
      id: 'Latvia',
      th: 'ลัตเวีย',
      vi: ' Latvia ',
      'zh-cn': '拉脱维亚',
      'zh-tw': '拉脫維亞',
    },
  },
  {
    areacode: '+372',
    translate: {
      en: 'Estonia',
      id: 'Estonia',
      th: 'เอสโตเนีย',
      vi: ' Estonia ',
      'zh-cn': '爱沙尼亚',
      'zh-tw': '愛沙尼亞',
    },
  },
  {
    areacode: '+373',
    translate: {
      en: 'Moldova',
      id: 'Moldova',
      th: 'มอลโดวา',
      vi: ' Moldova ',
      'zh-cn': '摩尔多瓦',
      'zh-tw': '摩爾多瓦',
    },
  },
  {
    areacode: '+374',
    translate: {
      en: 'Armenia',
      id: 'Armenia',
      th: 'อาร์เมเนีย',
      vi: ' Armenia ',
      'zh-cn': '亚美尼亚',
      'zh-tw': '亞美尼亞',
    },
  },
  {
    areacode: '+375',
    translate: {
      en: 'Belarus',
      id: 'Belarus',
      th: 'เบลารุส',
      vi: ' Bêlarut ',
      'zh-cn': '白俄罗斯',
      'zh-tw': '白俄羅斯',
    },
  },
  {
    areacode: '+376',
    translate: {
      en: 'Republic of Andorra',
      id: 'Republik Andorra',
      th: 'สาธารณรัฐอันดอร์รา',
      vi: ' Cộng hòa Andorra ',
      'zh-cn': '安道尔共和国',
      'zh-tw': '安道爾共和國',
    },
  },
  {
    areacode: '+377',
    translate: {
      en: 'Monaco',
      id: 'Monaco',
      th: 'โมนาโก',
      vi: ' Monaco ',
      'zh-cn': '摩纳哥',
      'zh-tw': '摩納哥',
    },
  },
  {
    areacode: '+378',
    translate: {
      en: 'San Marino',
      id: 'San Marino',
      th: 'ซานมารีโน',
      vi: ' San Marino ',
      'zh-cn': '圣马力诺',
      'zh-tw': '聖馬力諾',
    },
  },
  {
    areacode: '+380',
    translate: {
      en: 'Ukraine',
      id: 'Ukraina',
      th: 'ยูเครน',
      vi: ' Ukraine ',
      'zh-cn': '乌克兰',
      'zh-tw': '烏克蘭',
    },
  },
  {
    areacode: '+386',
    translate: {
      en: 'Slovenia',
      id: 'Slovenia',
      th: 'สโลวีเนีย',
      vi: ' Slovenia ',
      'zh-cn': '斯洛文尼亚',
      'zh-tw': '斯洛文尼亞',
    },
  },
  {
    areacode: '+420',
    translate: {
      en: 'Czech Republic',
      id: 'Republik Ceko',
      th: 'สาธารณรัฐเช็ก',
      vi: ' Cộng hòa Séc ',
      'zh-cn': '捷克',
      'zh-tw': '捷克',
    },
  },
  {
    areacode: '+421',
    translate: {
      en: 'Slovakia',
      id: 'Slovakia',
      th: 'สโลวะเกีย',
      vi: ' Slovakia ',
      'zh-cn': '斯洛伐克',
      'zh-tw': '斯洛伐克',
    },
  },
  {
    areacode: '+423',
    translate: {
      en: 'Liechtenstein',
      id: 'Liechtenstein',
      th: 'ราชรัฐลิกเตนสไตน์',
      vi: ' Liechtenstein ',
      'zh-cn': '列支敦士登',
      'zh-tw': '列支敦士登',
    },
  },
  {
    areacode: '+501',
    translate: {
      en: 'Belize',
      id: 'Belize',
      th: 'เบลีซ',
      vi: ' Belize ',
      'zh-cn': '伯利兹',
      'zh-tw': '伯利茲',
    },
  },
  {
    areacode: '+502',
    translate: {
      en: 'Guatemala',
      id: 'Guatemala',
      th: 'กัวเตมาลา',
      vi: ' Guatemala ',
      'zh-cn': '瓜地马拉',
      'zh-tw': '瓜地馬拉',
    },
  },
  {
    areacode: '+503',
    translate: {
      en: 'El Salvador',
      id: 'El Salvador',
      th: 'เอลซัลวาดอร์',
      vi: ' El Salvador ',
      'zh-cn': '萨尔瓦多',
      'zh-tw': '薩爾瓦多',
    },
  },
  {
    areacode: '+504',
    translate: {
      en: 'Honduras',
      id: 'Honduras',
      th: 'ฮอนดูรัส',
      vi: ' Honduras ',
      'zh-cn': '洪都拉斯',
      'zh-tw': '洪都拉斯',
    },
  },
  {
    areacode: '+505',
    translate: {
      en: 'Nicaragua',
      id: 'Nikaragua',
      th: 'นิการากัว',
      vi: ' Nicaragua ',
      'zh-cn': '尼加拉瓜',
      'zh-tw': '尼加拉瓜',
    },
  },
  {
    areacode: '+506',
    translate: {
      en: 'Costa Rica',
      id: 'Kosta Rika',
      th: 'คอสตาริกา',
      vi: ' Costa Rica ',
      'zh-cn': '哥斯达黎加',
      'zh-tw': '哥斯達黎加',
    },
  },
  {
    areacode: '+507',
    translate: {
      en: 'Panama',
      id: 'Panama',
      th: 'ปานามา',
      vi: ' Panama ',
      'zh-cn': '巴拿马',
      'zh-tw': '巴拿馬',
    },
  },
  {
    areacode: '+509',
    translate: {
      en: 'Haiti',
      id: 'Haiti',
      th: 'เฮติ',
      vi: ' Haiti ',
      'zh-cn': '海地',
      'zh-tw': '海地',
    },
  },
  {
    areacode: '+591',
    translate: {
      en: 'Bolivia',
      id: 'Bolivia',
      th: 'โบลิเวีย',
      vi: ' Bôlivia ',
      'zh-cn': '玻利维亚',
      'zh-tw': '玻利維亞',
    },
  },
  {
    areacode: '+592',
    translate: {
      en: 'Guyana',
      id: 'Guyana',
      th: 'กายอานา',
      vi: ' Guyana ',
      'zh-cn': '圭亚那',
      'zh-tw': '圭亞那',
    },
  },
  {
    areacode: '+593',
    translate: {
      en: 'Ecuador',
      id: 'Ekuador',
      th: 'เอกวาดอร์',
      vi: ' Ecuador ',
      'zh-cn': '厄瓜多尔',
      'zh-tw': '厄瓜多爾',
    },
  },
  {
    areacode: '+594',
    translate: {
      en: 'French Guiana',
      id: 'Guyana Perancis',
      th: 'เฟรนช์เกียนา',
      vi: ' Guiana thuộc Pháp ',
      'zh-cn': '法属圭亚那',
      'zh-tw': '法屬圭亞那',
    },
  },
  {
    areacode: '+595',
    translate: {
      en: 'Paraguay',
      id: 'Paraguay',
      th: 'ปารากวัย',
      vi: ' Paraguay ',
      'zh-cn': '巴拉圭',
      'zh-tw': '巴拉圭',
    },
  },
  {
    areacode: '+596',
    translate: {
      en: 'Martinique',
      id: 'Martinique',
      th: 'มาร์ตินีก',
      vi: ' Martinique ',
      'zh-cn': '马提尼克',
      'zh-tw': '馬提尼克',
    },
  },
  {
    areacode: '+597',
    translate: {
      en: 'Suriname',
      id: 'Suriname',
      th: 'ซูรินาเม',
      vi: ' Suriname ',
      'zh-cn': '苏里南',
      'zh-tw': '蘇裏南',
    },
  },
  {
    areacode: '+598',
    translate: {
      en: 'Uruguay',
      id: 'Uruguay',
      th: 'อุรุกวัย',
      vi: ' Uruguay ',
      'zh-cn': '乌拉圭',
      'zh-tw': '烏拉圭',
    },
  },
  {
    areacode: '+673',
    translate: {
      en: 'Brunei',
      id: 'Brunei',
      th: 'บรูไน',
      vi: ' Brunei ',
      'zh-cn': '文莱',
      'zh-tw': '文萊',
    },
  },
  {
    areacode: '+675',
    translate: {
      en: 'Papua New Guinea',
      id: 'Papua Nugini',
      th: 'ปาปัวนิวกีนี',
      vi: ' Papua New Guinea ',
      'zh-cn': '巴布亚新几内亚',
      'zh-tw': '巴布亞新幾內亞',
    },
  },
  {
    areacode: '+676',
    translate: {
      en: 'Tonga',
      id: 'Tonga',
      th: 'ตองกา',
      vi: ' Tonga ',
      'zh-cn': '汤加',
      'zh-tw': '湯加',
    },
  },
  {
    areacode: '+677',
    translate: {
      en: 'Solomon Islands',
      id: 'Kepulauan Solomon',
      th: 'หมู่เกาะโซโลมอน',
      vi: ' Quần đảo Solomon ',
      'zh-cn': '所罗门群岛',
      'zh-tw': '所羅門群島',
    },
  },
  {
    areacode: '+679',
    translate: {
      en: 'Fiji',
      id: 'Fiji',
      th: 'ฟิจิ',
      vi: ' Fiji ',
      'zh-cn': '斐济',
      'zh-tw': '斐濟',
    },
  },
  {
    areacode: '+682',
    translate: {
      en: 'Cook Islands',
      id: 'Kepulauan Cook',
      th: 'หมู่เกาะคุก',
      vi: ' Quần đảo Cook ',
      'zh-cn': '库克群岛',
      'zh-tw': '庫克群島',
    },
  },
  {
    areacode: '+689',
    translate: {
      en: 'French Polynesia',
      id: 'Polinesia Perancis',
      th: 'เฟรนช์โปลินีเซีย',
      vi: ' Polynesia thuộc Pháp ',
      'zh-cn': '法属波利尼西亚',
      'zh-tw': '法屬波利尼西亞',
    },
  },
  {
    areacode: '+853',
    translate: {
      en: 'Macau, China',
      id: 'Macau, Cina',
      th: 'มาเก๊า, จีน',
      vi: ' Ma Cao, Trung Quốc ',
      'zh-cn': '中国澳门',
      'zh-tw': '中國澳門',
    },
  },
  {
    areacode: '+855',
    translate: {
      en: 'Cambodia',
      id: 'Kamboja',
      th: 'กัมพูชา',
      vi: ' Campuchia ',
      'zh-cn': '柬埔寨',
      'zh-tw': '柬埔寨',
    },
  },
  {
    areacode: '+856',
    translate: {
      en: 'Laos',
      id: 'Laos',
      th: 'ลาว',
      vi: ' Lào ',
      'zh-cn': '老挝',
      'zh-tw': '老撾',
    },
  },
  {
    areacode: '+880',
    translate: {
      en: 'Bangladesh',
      id: 'Bangladesh',
      th: 'บังกลาเทศ',
      vi: ' Bangladesh ',
      'zh-cn': '孟加拉国',
      'zh-tw': '孟加拉國',
    },
  },
  {
    areacode: '+960',
    translate: {
      en: 'Maldives',
      id: 'Maladewa',
      th: 'มัลดีฟส์',
      vi: ' Maldives ',
      'zh-cn': '马尔代夫',
      'zh-tw': '馬爾代夫',
    },
  },
  {
    areacode: '+961',
    translate: {
      en: 'Lebanon',
      id: 'Libanon',
      th: 'เลบานอน',
      vi: ' Lebanon ',
      'zh-cn': '黎巴嫩',
      'zh-tw': '黎巴嫩',
    },
  },
  {
    areacode: '+962',
    translate: {
      en: 'Jordan',
      id: 'Yordania',
      th: 'จอร์แดน',
      vi: ' Jordan ',
      'zh-cn': '约旦',
      'zh-tw': '約旦',
    },
  },
  {
    areacode: '+963',
    translate: {
      en: 'Syria',
      id: 'Suriah',
      th: 'ซีเรีย',
      vi: ' Syria ',
      'zh-cn': '叙利亚',
      'zh-tw': '敘利亞',
    },
  },
  {
    areacode: '+964',
    translate: {
      en: 'Iraq',
      id: 'Irak',
      th: 'อิรัก',
      vi: ' Iraq ',
      'zh-cn': '伊拉克',
      'zh-tw': '伊拉克',
    },
  },
  {
    areacode: '+965',
    translate: {
      en: 'Kuwait',
      id: 'Kuwait',
      th: 'คูเวต',
      vi: ' Kuwait ',
      'zh-cn': '科威特',
      'zh-tw': '科威特',
    },
  },
  {
    areacode: '+966',
    translate: {
      en: 'Saudi Arabia',
      id: 'Arab Saudi',
      th: 'ซาอุดิอาระเบีย',
      vi: ' Ả Rập Saudi ',
      'zh-cn': '沙特阿拉伯',
      'zh-tw': '沙特阿拉伯',
    },
  },
  {
    areacode: '+967',
    translate: {
      en: 'Yemen',
      id: 'Yaman',
      th: 'เยเมน',
      vi: ' Yemen ',
      'zh-cn': '也门',
      'zh-tw': '也門',
    },
  },
  {
    areacode: '+968',
    translate: {
      en: 'Oman',
      id: 'Oman',
      th: 'โอมาน',
      vi: ' Ô-man ',
      'zh-cn': '阿曼',
      'zh-tw': '阿曼',
    },
  },
  {
    areacode: '+971',
    translate: {
      en: 'United Arab Emirates',
      id: 'Uni Emirat Arab',
      th: 'สหรัฐอาหรับเอมิเรต',
      vi: ' Các tiểu vương quốc Ả Rập thống nhất ',
      'zh-cn': '阿拉伯联合酋长国',
      'zh-tw': '阿拉伯聯合酋長國',
    },
  },
  {
    areacode: '+972',
    translate: {
      en: 'Israel',
      id: 'Israel',
      th: 'อิสราเอล',
      vi: ' Israel ',
      'zh-cn': '以色列',
      'zh-tw': '以色列',
    },
  },
  {
    areacode: '+973',
    translate: {
      en: 'Bahrain',
      id: 'Bahrain',
      th: 'บาห์เรน',
      vi: ' Bahrain ',
      'zh-cn': '巴林',
      'zh-tw': '巴林',
    },
  },
  {
    areacode: '+974',
    translate: {
      en: 'Qatar',
      id: 'Qatar',
      th: 'กาตาร์',
      vi: ' Qatar ',
      'zh-cn': '卡塔尔',
      'zh-tw': '卡塔爾',
    },
  },
  {
    areacode: '+976',
    translate: {
      en: 'Mongolia',
      id: 'Mongolia',
      th: 'มองโกเลีย',
      vi: ' Mông Cổ ',
      'zh-cn': '蒙古',
      'zh-tw': '蒙古',
    },
  },
  {
    areacode: '+977',
    translate: {
      en: 'Nepal',
      id: 'Nepal',
      th: 'เนปาล',
      vi: ' Nepal ',
      'zh-cn': '尼泊尔',
      'zh-tw': '尼泊爾',
    },
  },
  {
    areacode: '+992',
    translate: {
      en: 'Tajikistan',
      id: 'Tajikistan',
      th: 'ทาจิกิสถาน',
      vi: ' Tajikistan ',
      'zh-cn': '塔吉克斯坦',
      'zh-tw': '塔吉克斯坦',
    },
  },
  {
    areacode: '+993',
    translate: {
      en: 'Turkmenistan',
      id: 'Turkmenistan',
      th: 'เติร์กเมนิสถาน',
      vi: ' Turkmenistan ',
      'zh-cn': '土库曼斯坦',
      'zh-tw': '土庫曼斯坦',
    },
  },
  {
    areacode: '+994',
    translate: {
      en: 'Azerbaijan',
      id: 'Azerbaijan',
      th: 'อาเซอร์ไบจาน',
      vi: ' Ailen ',
      'zh-cn': '阿塞拜疆',
      'zh-tw': '阿塞拜疆',
    },
  },
  {
    areacode: '+995',
    translate: {
      en: 'Georgia',
      id: 'Georgia',
      th: 'จอร์เจีย',
      vi: ' Georgia ',
      'zh-cn': '格鲁吉亚',
      'zh-tw': '格魯吉亞',
    },
  },
  {
    areacode: '+996',
    translate: {
      en: 'Kyrgyzstan',
      id: 'Kirgistan',
      th: 'คีร์กีซสถาน',
      vi: ' Kyrgyzstan ',
      'zh-cn': '吉尔吉斯斯坦',
      'zh-tw': '吉爾吉斯斯坦',
    },
  },
  {
    areacode: '+998',
    translate: {
      en: 'Uzbekistan',
      id: 'Uzbekistan',
      th: 'อุซเบกิสถาน',
      vi: ' Uzbekistan ',
      'zh-cn': '乌兹别克斯坦',
      'zh-tw': '烏茲別克斯坦',
    },
  },
  {
    areacode: '+1242',
    translate: {
      en: 'Bahamas',
      id: 'Bahama',
      th: 'บาฮามาส',
      vi: ' Bahamas ',
      'zh-cn': '巴哈马',
      'zh-tw': '巴哈馬',
    },
  },
  {
    areacode: '+1246',
    translate: {
      en: 'Barbados',
      id: 'Barbados',
      th: 'บาร์เบโดส',
      vi: ' Barbados ',
      'zh-cn': '巴巴多斯',
      'zh-tw': '巴巴多斯',
    },
  },
  {
    areacode: '+1264',
    translate: {
      en: 'Anguilla',
      id: 'Anguilla',
      th: 'แองกวิลลา',
      vi: ' Anguilla ',
      'zh-cn': '安圭拉岛',
      'zh-tw': '安圭拉島',
    },
  },
  {
    areacode: '+1268',
    translate: {
      en: 'Antigua and Barbuda',
      id: 'Antigua dan Barbuda',
      th: 'แอนติกาและบาร์บูดา',
      vi: ' Antigua và Barbuda ',
      'zh-cn': '安提瓜和巴布达',
      'zh-tw': '安提瓜和巴布達',
    },
  },
  {
    areacode: '+1345',
    translate: {
      en: 'Cayman Islands',
      id: 'Kepulauan Cayman',
      th: 'หมู่เกาะเคย์แมน',
      vi: ' Quần đảo Cayman ',
      'zh-cn': '开曼群岛',
      'zh-tw': '開曼群島',
    },
  },
  {
    areacode: '+1441',
    translate: {
      en: 'Bermuda Islands',
      id: 'Kepulauan Bermuda',
      th: 'หมู่เกาะเบอร์มิวดา',
      vi: ' Quần đảo Bermuda ',
      'zh-cn': '百慕大群岛',
      'zh-tw': '百慕大群島',
    },
  },
  {
    areacode: '+1473',
    translate: {
      en: 'Grenada',
      id: 'Grenada',
      th: 'เกรเนดา',
      vi: ' Grenada ',
      'zh-cn': '格林纳达',
      'zh-tw': '格林納達',
    },
  },
  {
    areacode: '+1664',
    translate: {
      en: 'Montserrat',
      id: 'Montserrat',
      th: 'มอนต์เซอร์รัต',
      vi: ' Montserrat ',
      'zh-cn': '蒙特塞拉特岛',
      'zh-tw': '蒙特塞拉特島',
    },
  },
  {
    areacode: '+1671',
    translate: {
      en: 'Guam',
      id: 'Guam',
      th: 'กวม',
      vi: ' đảo ',
      'zh-cn': '关岛',
      'zh-tw': '關島',
    },
  },
  {
    areacode: '+1758',
    translate: {
      en: 'Saint Lucia',
      id: 'Saint Lucia',
      th: 'เซนต์ลูเซีย',
      vi: ' Saint Lucia ',
      'zh-cn': '圣露西亚',
      'zh-tw': '聖露西亞',
    },
  },
  {
    areacode: '+1787',
    translate: {
      en: 'Puerto Rico',
      id: 'Puerto Riko',
      th: 'เปอร์โตริโก',
      vi: ' Puerto Rico ',
      'zh-cn': '波多黎各',
      'zh-tw': '波多黎各',
    },
  },
  {
    areacode: '+1809',
    translate: {
      en: 'Dominican Republic',
      id: 'Republik Dominika',
      th: 'สาธารณรัฐโดมินิกัน',
      vi: ' Cộng hòa Dominican ',
      'zh-cn': '多明尼加共和国',
      'zh-tw': '多明尼加共和國',
    },
  },
  {
    areacode: '+1868',
    translate: {
      en: 'Trinidad and Tobago',
      id: 'Trinidad dan Tobago',
      th: 'ตรินิแดดและโตเบโก',
      vi: ' Trinidad và Tobago ',
      'zh-cn': '特立尼达和多巴哥',
      'zh-tw': '特立尼達和多巴哥',
    },
  },
  {
    areacode: '+1876',
    translate: {
      en: 'Jamaica',
      id: 'Jamaika',
      th: 'จาเมกา',
      vi: ' Jamaica ',
      'zh-cn': '牙买加',
      'zh-tw': '牙買加',
    },
  },
  {
    areacode: '+381',
    translate: {
      en: 'Republic of Serbia',
      id: 'Republik Serbia',
      th: 'สาธารณรัฐเซอร์เบีย',
      vi: ' Cộng hòa Serbia ',
      'zh-cn': '塞尔维亚共和国',
      'zh-tw': '塞爾維亞共和國',
    },
  },
  {
    areacode: '+222',
    translate: {
      en: 'Mauritania',
      id: 'Mauritania',
      th: 'มอริเตเนีย',
      vi: ' Mauritania ',
      'zh-cn': '毛里塔尼亚',
      'zh-tw': '毛裏塔尼亞',
    },
  },
];
